import React from "react";
import weather from "../img/weather.png";
import onlineshop from "../img/shop.png";
import automatebefore from "../img/automate.png";
import quiz from "../img/quiz.png";
import PropTypes from "prop-types";


export default class Projects extends React.Component {

	render() {
		return (
			<React.Fragment>
				<div id="my-projects" className="container-fluid bg-light mt-5">
					<div className=" project-container container bg-light pb-5">
						<h1
							id="projects"
							className={"text-center " + this.props.fadeInRight}>
							Projects
						</h1>
						<div className="row my-5">
							<div
								className={
									"testbg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Online Shop</h2>
									</div>
									<div>
										<button
											id="vmarine-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var marineModal = document.getElementById(
													"vmarine"
												);
												modalBG.style.display = "block";
												marineModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>
							</div>
							<div
								className={
									"aguabg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Weather Forecaster</h2>
									</div>
									<div>
										<button
											id="agua-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var aguaModal = document.getElementById(
													"agualuz"
												);
												modalBG.style.display = "block";
												aguaModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>
							</div>
							<div
								className={
									"todobg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Search Mate</h2>
									</div>
									<div>
										<button
											id="todo-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var todoModal = document.getElementById(
													"todolist"
												);
												modalBG.style.display = "block";
												todoModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>
							</div>
							<div
								className={
									"quizbg col-12 col-sm-12 col-md-4 " +
									this.props.fadeIn
								}>
								<div className="overlay">
									<div className="text">
										<h2>Quiz Game</h2>
									</div>
									<div>
										<button
											id="quiz-button"
											className="project-button"
											onClick={() => {
												var modalBG = document.getElementById(
													"gallery-card"
												);
												var quizModal = document.getElementById(
													"quiz"
												);
												modalBG.style.display = "block";
												quizModal.style.display =
													"block";
											}}>
											Learn More
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				{/*hidden modals*/}
				<div id="gallery-card">
					<div id="vmarine" className="modal-card">
						<div className="visual">
							<img src={onlineshop} alt=""/>
						</div>
						<div className="modal-info">
							<h2>Online Shop</h2>
							<div className="modal-description">
								<ul>
									<li>
										An Online shop with form validation and Stripe Payment system. User can post their product too sell.
									</li>
									<li>
										Developed with Express.js, Handlebars, MongoDB, Bootstrap.
									</li>
								</ul>
							</div>
							<div className="modal-bottom">
								<a 
									href="https://onlinesshop789.herokuapp.com/"
									target="_blank">
									<h3>View live demo</h3>
								</a>
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var marineModal = document.getElementById(
											"vmarine"
										);
										modalBG.style.display = "none";
										marineModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>

					<div id="agualuz" className="modal-card">
						<div className="visual">
							<img src={weather} alt=""/>
						</div>
						<div className="modal-info">
							<h2>Weather Forecaster</h2>
							<div className="modal-description">
								<ul>
									<li>
										A Weather forecaster with city and country name.
									</li>
									<li>
										Developed with opeweathermap api and React.js.
									</li>
								</ul>
							</div>
							<div className="modal-bottom">
								<a
									href="https://weather-forecaster666.herokuapp.com/"
									target="_blank">
									<h3>View live demo</h3>
								</a>
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var aguaModal = document.getElementById(
											"agualuz"
										);
										modalBG.style.display = "none";
										aguaModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>

					<div id="todolist" className="modal-card">
						<div className="visual">
							<img src={automatebefore} alt=""/>
						</div>
						<div className="modal-info">
							<h2>Search Mate</h2>
							<div className="modal-description">
								<ul>
									<li>
										An Automatated website.You can find products from bikroy, cellbazar, pickaboo all in one place.. You can find movies,series and torrets here too.
									</li>
									<li>
										Developed with Express.js, Handlebars,Bootstrap, cheerio.
									</li>
								</ul>
							</div>
							<div className="modal-bottom">
								<a href="https://searchmate.herokuapp.com/" target="_blank">
									<h3>View live demo</h3>
								</a>
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var todoModal = document.getElementById(
											"todolist"
										);
										modalBG.style.display = "none";
										todoModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>
					<div id="quiz" className="modal-card">
						<div className="visual">
							<img src={quiz} alt=""/>
						</div>
						<div className="modal-info">
							<h2>Quiz Game</h2>
							<div className="modal-description">
								<ul>
									<li>
										A quiz game based on high school textbook.
									</li>
									<li>
										Developed with Express.js, Html,Bootstrap, socket.io , jquery.
									</li>
								</ul>
							</div>
							<div className="modal-bottom">
								<a href="https://quizzgamee.herokuapp.com/" target="_blank">
									<h3>View live demo</h3>
								</a>
								<p
									className="close-icon"
									style={{
										textAlign: "right",
										fontWeight: 900,
										fontSize: 2 + "rem",
										cursor: "pointer"
									}}
									onClick={() => {
										var modalBG = document.getElementById(
											"gallery-card"
										);
										var quizModal = document.getElementById(
											"quiz"
										);
										modalBG.style.display = "none";
										quizModal.style.display = "none";
									}}>
									&#10005;
								</p>
							</div>
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

Projects.propTypes = {
	bounceIn: PropTypes.string,
	fadeInLeft: PropTypes.string,
	fadeInRight: PropTypes.string,
	fadeIn: PropTypes.string,
	tada: PropTypes.string
};
